import React from "react";
import styled, { css } from "styled-components";

const Group = styled.div(
  ({ theme }) => css`
    display: inline-flex;
    border: 1px solid ${theme.colors.black};
    border-radius: 10px;
    overflow: hidden;
  `
);

const Option = styled.button<{ selected: boolean }>(
  ({ theme, selected }) => css`
    min-width: 72px;
    padding: ${theme.spaceUnit.xs} ${theme.spaceUnit.md};
    border: none;
    background: ${selected ? theme.colors.black : theme.colors.white};
    color: ${selected ? theme.colors.white : theme.colors.black};
    font-size: 14px;
    cursor: pointer;

    & + & {
      border-left: 1px solid ${theme.colors.black};
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  `
);

interface IProps {
  label: string;
  /** null = unknown: neither option is selected. */
  value: boolean | null;
  onText: string;
  offText: string;
  disabled: boolean;
  onChange: (value: boolean) => void;
}

/** Compact On | Off control for a boolean setting. */
const OnOffSwitch: React.FC<IProps> = ({ label, value, onText, offText, disabled, onChange }) => (
  <Group role="radiogroup" aria-label={label}>
    <Option
      type="button"
      role="radio"
      aria-checked={value === true}
      selected={value === true}
      disabled={disabled}
      onClick={() => onChange(true)}
    >
      {onText}
    </Option>
    <Option
      type="button"
      role="radio"
      aria-checked={value === false}
      selected={value === false}
      disabled={disabled}
      onClick={() => onChange(false)}
    >
      {offText}
    </Option>
  </Group>
);

export default OnOffSwitch;
